import { useMemo } from 'react';

import { useLocation, useParams } from '../../../contexts/RouterContext';
import type { RevisionRouteParams } from '../../../components/projects/projectDashboardTypes';

import useGetProject from './useGetProject';

/**
 * Fetches the current project based on the URL params.
 */
export function useCurrentProject(shouldFetch = true) {
  const params = useParams<RevisionRouteParams>();
  const location = useLocation();

  const getProjectParams = useMemo(() => ({
    ref_type: params.reference_type || 'branch',
    ref: params.reference,
    //  TODO: do we actually need badge_ref? can we kill it?
    ...(location?.query?.ref ? { badge_ref: location.query.ref } : {}),
  }), [params, location]);

  //  Don't fetch if we don't have a project_id
  const shouldEnableFetching = !!params.project_id && shouldFetch;
  return useGetProject(params.project_id, getProjectParams, shouldEnableFetching);
}
